import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

var _createAction;

import { FTUE_STEPS_KEYS } from '../../constants';
import getActiveRouteDescriptor from '../../utils/getActiveRouteDescriptor';
import navigation from '../../utils/navigation/navigation';
import QueryParamProxy from '../../utils/queryParamProxy';
import routeParamConstants from '../../utils/routeParamConstants';
import { MissionTutorialStepsKeys, TUTORIAL_NAME } from '../../utils/tutorial';
import { ACTION_COMMANDS_TYPE } from './constants/types';
import { getScreenByActionType, getScreenByModalType, getTooltipByType } from './utils';

var handleDisplayModalAction = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var modal, actionCommands;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            modal = _ref.modal;
            actionCommands = QueryParamProxy.setQueryParamsWithModalPromise(_defineProperty({}, routeParamConstants.PARAM_MODAL, getScreenByModalType[modal.modalType] || getScreenByModalType['default']));
            _context.next = 4;
            return actionCommands;

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleDisplayModalAction(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var handleDisplayTooltipAction = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(actionCommands, props) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            getTooltipByType[actionCommands.tooltip.tooltipType](actionCommands, props) || getTooltipByType['default'];

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleDisplayTooltipAction(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

var handleDisplayGameTutorialAction = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(actionCommand, props) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            props.setFtueState(true);
            props.setFtueGameId(actionCommand.gameTutorial.gameId.toString());
            if (props.ftueStep !== FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME) props.setOnboardingFtueStep(FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function handleDisplayGameTutorialAction(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();

var handleDisplayMissionsTutorialAction = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(actionCommand, props) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (props.tutorialStep === MissionTutorialStepsKeys.CHECK_OUT) {
              props.setActiveTutorial({
                activeTutorial: true,
                tutorialName: TUTORIAL_NAME.MISSIONS_TUTORIAL,
                blockLobby: true
              });
            }

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function handleDisplayMissionsTutorialAction(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

var handleDisplayEventsTutorialAction = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            QueryParamProxy.navigate(navigation, getScreenByActionType[ACTION_COMMANDS_TYPE.DISPLAY_EVENTS_TUTORIAL], _defineProperty({}, routeParamConstants.PARAM_SWEEPSTAKE_TUTORIAL, true));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function handleDisplayEventsTutorialAction() {
    return _ref6.apply(this, arguments);
  };
}();

var handleNotification = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(actionCommand, props) {
    var _actionCommand$payloa;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            props.setRewardCenterNotification(actionCommand === null || actionCommand === void 0 ? void 0 : (_actionCommand$payloa = actionCommand.payload) === null || _actionCommand$payloa === void 0 ? void 0 : _actionCommand$payloa.newOffersCount);
            props.clearLastActionCommand();

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function handleNotification(_x8, _x9) {
    return _ref7.apply(this, arguments);
  };
}();

var createAction = (_createAction = {}, _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_MODAL, handleDisplayModalAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_TOOLTIP, handleDisplayTooltipAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_GAME_TUTORIAL, handleDisplayGameTutorialAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_MISSIONS_TUTORIAL, handleDisplayMissionsTutorialAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.DISPLAY_EVENTS_TUTORIAL, handleDisplayEventsTutorialAction), _defineProperty(_createAction, ACTION_COMMANDS_TYPE.NOTIFICATION, handleNotification), _defineProperty(_createAction, "default", function _default() {}), _createAction);

var ActionsInterface = function ActionsInterface(props) {
  var activeScreen = getActiveRouteDescriptor(props).key;

  for (var i = 0; i < props.actionCommands.length; i++) {
    var _props$actionCommands, _props$actionCommands2;

    if (((_props$actionCommands = props.actionCommands[i]) === null || _props$actionCommands === void 0 ? void 0 : (_props$actionCommands2 = _props$actionCommands.payload) === null || _props$actionCommands2 === void 0 ? void 0 : _props$actionCommands2.screen) === activeScreen) {
      var _props$actionCommands3;

      props.setLastActionExecuted(props.actionCommands[i]);
      createAction[(_props$actionCommands3 = props.actionCommands[i]) === null || _props$actionCommands3 === void 0 ? void 0 : _props$actionCommands3.actionType](props.actionCommands[i], props) || createAction['default']();
      break;
    }
  }
};

export default ActionsInterface;